module.exports = __webpack_public_path__ + "img/CHEVRON_LEFT.5d3e1b20.svg";